<template>
  <!-- start 微信登录 -->
  <div class="dialog-box" v-if="open" @click="preventClick">
    <div class="wechat-login">
      <img
        class="wechat-login-left-img"
        src="@/assets/images/login-banner-item.png"
      />
      <div class="wechat-login-content">
        <div class="closed-container">
          <img
            class="close-img"
            src="@/assets/images/vip-close-icon.png"
            @click="close()"
          />
        </div>
        <div class="login-title">快捷安全登录/注册</div>
        <div class="login-content">
          <div class="qr">
            <div class="anew-load" v-if="isload">
              <div class="loading"></div>
              <!-- <img class="anew-load-img" src="@/assets/images/load-iocn.png" /> -->
            </div>
            <img
              class="qr-img"
              :src="loginParam.url"
              @click="refreshLoginInfo"
              @load="imgLoaded"
            />
          </div>
          <div class="font-style" style="margin-top: 40px">
            请使用微信扫描二维码登录
          </div>
          <div class="font-style">“打字通”</div>
          <div class="font-style" style="margin-top: 41px">
            登录即同意《打字通用户协议及隐私政策》
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end 微信登录 -->
</template>

<script>
export default {
  name: "WeChatLogin",
  data() {
    return {
      // 是否重新加载
      isload: true,
      // 登录参数
      loginParam: {},
      // 定时器
      timer: null,
    };
  },
  props: {
    open: {
      typeof: Boolean,
      default: false,
    },
  },
  watch: {
    open: {
      handler(newVal) {
        if (newVal) {
          this.onloadWxQr();
        }
      },
    },
  },
  methods: {
    imgLoaded(e) {
      this.isload = false;
    },
    // 加载微信登录二维码
    onloadWxQr() {
      let windowDeviceId = window.win_device_id;
      if (typeof window.win_device_id === "function") {
        windowDeviceId = window.win_device_id();
      }
      let sourceId = window.win_source;
      if (typeof window.win_source === "function") {
        sourceId = window.win_source();
      }
      let data = {
        curr_ver: "22.2.0.6", //版本号
        soft_id: "typing_pass_win", //软件标识
        device_id: "windows", //设备类型
        device_code: windowDeviceId, //设备码
        mac_code: "xxxxxxc", //机器码
        source: sourceId, //来源
        os: 1,
      };
      this.$http({
        url: "http://api.kuaixunda.cn/api/ewm",
        method: "get",
        params: data,
      }).then(({ data }) => {
        if (data.code == 0) {
          this.loginParam = data.data;
          this.getLoginUserInfoToken();
        }
      });
    },
    // 获取token
    getToken() {
      let data = {
        temporary_id: this.loginParam.ewm_id,
        source: window.win_source(),
      };
      this.$http({
        url: "https://api.kuaixunda.cn/api/getToken",
        method: "get",
        params: data,
      }).then(({ data }) => {
        if (data.data.token != "") {
          clearTimeout(this.timer);
          localStorage.setItem("token", data.data.token);
          this.onloadUser(data.data.token);
          this.$emit("wxLoginOk");
          this.$emit("close");
        }
      });
    },
    // 加载用户
    onloadUser(token) {
      let data = {
        token: token,
      };
      this.$http({
        url: "https://api.kuaixunda.cn/api/mem_profile",
        method: "get",
        params: data,
      }).then(({ data }) => {
        localStorage.setItem("wxUserInfo", JSON.stringify(data.data));
      });
    },
    // 获取登录信息
    getLoginUserInfoToken() {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
      this.timer = setInterval(() => {
        //需要定时执行的代码
        this.getToken();
      }, 2000);
    },
    // 刷新登录信息
    refreshLoginInfo() {
      this.isload = true;
      this.onloadWxQr();
    },
    //关闭弹窗
    close() {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
      this.$emit("close");
    },
    // 防止点击
    preventClick() {},
  },
};
</script>

<style lang="scss" scoped>
.loading {
  width: 40px;
  height: 40px;
  border: 5px solid #f3f3f3; /* 灰色的边框，作为背景 */
  border-top: 5px solid #3498db; /* 蓝色的顶部边框，用于动画效果 */
  border-radius: 50%;
  animation: spin 1s linear infinite; /* 应用名为spin的动画，持续1秒，线性，无限循环 */
}
@keyframes spin {
  from {
    transform: rotate(0deg); /* 从0度开始旋转 */
  }
  to {
    transform: rotate(360deg); /* 旋转到360度 */
  }
}
.dialog-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  .wechat-login {
    width: 680px;
    height: 420px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    outline: none;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    display: flex;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1607843137254902);
    .wechat-login-left-img {
      width: 260px;
      height: 100%;
    }
    .wechat-login-content {
      flex: 1;
      position: relative;

      .closed-container {
        width: 40px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: absolute;
        right: 6px;
        top: 6px;
        .close-img {
          width: 30px;
          height: 28px;
        }
      }
      .closed-container:hover {
        background-color: rgba(153, 148, 148, 0.2);
      }
      .login-title {
        margin-top: 39px;
        margin-left: 45px;
        font-size: 18px;
        font-weight: bold;
        color: #2d2d2d;
      }
      .login-content {
        display: flex;
        align-items: center;
        margin-top: 41px;
        flex-direction: column;
        .font-style {
          line-height: 24px;
          color: #999999;
          font-weight: 400;
          font-size: 14px;
        }
        .qr {
          width: 140px;
          height: 140px;
          position: relative;
          .anew-load {
            top: 0px;
            position: absolute;
            width: 100%;
            height: 100%;
            background: #0000002e;
            opacity: 0.6;
            display: flex;
            align-items: center;
            justify-content: center;
            .anew-load-img {
              width: 40px;
              height: 40px;
            }
          }
          .qr-img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>

